import React, { useEffect } from "react";
import "./corporate-enquiry.css";
import {
  Button,
  FormControl,
  TextField,
  TablePagination,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BASE_URL } from "../../shared/constants";

const CorporateEnquiry = () => {
  let [data, setData] = React.useState([]);
  let [searchData, setSearchData] = React.useState([]);
  const [exportLoading, setExportLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [totalCount, setTotalCount] = React.useState(0);

  // Filter states
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [mobile, setMobile] = React.useState("");

  useEffect(() => {
    getdetails();
  }, []);

  // Re-fetch when page or rowsPerPage change
  useEffect(() => {
    getdetails();
  }, [page, rowsPerPage]);

  const buildQueryParams = (pageNo, pageSize) => {
    const params = new URLSearchParams();
    params.append("pageNo", pageNo);
    params.append("pageSize", pageSize);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (email) params.append("email", email);
    if (mobile) params.append("mobile", mobile);
    return params.toString();
  };

  // TODO: Replace the endpoint below with the actual API path once available
  const getdetails = async () => {
    try {
      const query = buildQueryParams(page + 1, rowsPerPage);
      const res = await axios.get(
        `${BASE_URL}/get-corporate-enquiries?${query}`,
        {},
      );
      setData(res?.data?.data || []);
      setSearchData(res?.data?.data || []);
      setTotalCount(res?.data?.total_count || 0);
    } catch (err) {
      console.error("Failed to fetch corporate enquiries:", err);
    }
  };

  const exportData = async () => {
    setExportLoading(true);
    try {
      const query = buildQueryParams(1, 10000);
      const res = await axios.get(
        `${BASE_URL}/get-corporate-enquiries?${query}`,
        {},
      );
      const xlsData = res?.data?.data || [];
      const worksheet = XLSX.utils.json_to_sheet(xlsData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });

      saveAs(
        blob,
        "Corporate Enquiry " +
          moment.utc().format("DD-MMM-YYYY HH:mm") +
          ".xlsx",
      );
    } catch (err) {
      console.error("Failed to export corporate enquiries:", err);
    }
    setExportLoading(false);
  };

  const filterData = () => {
    setPage(0);
    getdetails();
  };

  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setEmail("");
    setMobile("");
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="pr-m-wrapper">
      <div className="pr-header-container">
        <span className="pr-header">Corporate Enquiry</span>
        <div className="btn-container">
          {exportLoading ? (
            <CircularProgress />
          ) : (
            <Button
              onClick={exportData}
              variant="contained"
              className="bordered-button"
            >
              Export Data
            </Button>
          )}
        </div>
      </div>

      <div className="filter-cb">
        <FormControl size="small">
          <TextField
            type="date"
            label="Start Date"
            variant="outlined"
            className="input-set"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>

        <FormControl size="small">
          <TextField
            type="date"
            label="End Date"
            variant="outlined"
            className="input-set"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>

        <FormControl size="small">
          <TextField
            label="Email"
            variant="outlined"
            className="input-set"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>

        <FormControl size="small">
          <TextField
            label="Mobile"
            variant="outlined"
            className="input-set"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </FormControl>

        <Button
          onClick={filterData}
          variant="contained"
          className="bordered-button"
        >
          Filter
        </Button>

        <Button
          onClick={clearFilters}
          variant="outlined"
          className="bordered-button"
        >
          Clear
        </Button>
      </div>

      <div className="pr-outer-table">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Company Name</th>
              <th scope="col">Contact Person</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">City</th>
              <th scope="col">Requirement</th>
            </tr>
          </thead>
          <tbody>
            {searchData?.map((o, i) => (
              <tr key={i}>
                <td>
                  {o?.createdAt
                    ? moment(o.createdAt).format("DD-MMM-YYYY")
                    : "-"}
                </td>
                <td>{o?.company || "-"}</td>
                <td>{o?.name || "-"}</td>
                <td>{o?.email || "-"}</td>
                <td>{o?.mobile || "-"}</td>
                <td>{o?.city || "-"}</td>
                <td>{o?.requirements || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <TablePagination
          rowsPerPageOptions={[20, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
};

export default CorporateEnquiry;
